export function addItem(map, key, item) {
    if (!map.has(key)) {
        map.set(key, []);
    }
    map.get(key).push(item);
}
//# sourceMappingURL=MapHelpers.js.map